import axios from 'axios'
import router from '../router/index'
import store from '../store/index'
import { ElMessage } from 'element-plus'

// 设置请求超时
// axios.defaults.timeout = 500

// 拦截器
axios.interceptors.request.use(
  config => {
    config.headers.token = localStorage.getItem('token') || ''
    // 如果是 FormData，不要设置 Content-Type，让浏览器自动设置
    if (config.data instanceof FormData) {
      // 删除可能存在的 Content-Type，让浏览器自动生成
      delete config.headers['Content-Type']
    } else {
      // 非 FormData 请求，设置默认的 JSON Content-Type
      config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    }
    return config
  }, error => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      // ElMessage(response.data.text)
      if (response.data.code !== 0) {
        ElMessage(response.data.text)
        // token验证失败处理
        if ([4101, 4102, 4103, 4104, 4105].includes(response.data.code)) {
          store.commit('deltoken')
          router.replace({
            path: '/',
            query: { redirect: router.currentRoute.fullPath }
          })
        }
      }
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        case 401:
          ElMessage('未登录')
          router.replace({
            path: '/',
            query: {
              redirect: router.currentRoute.fullPath
            }
          })
          break
        case 404:
          ElMessage('网络请求不存在')
          break
        default:
          ElMessage(error.ElMessage)
          break
      }
      return Promise.reject(error)
    }
  }
)

// get请求
export function get (url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err.data)
    })
  })
}

// 异步post请求
export function post (url, params) {
  return new Promise((resolve, reject) => {
    // 判断是否需要使用 FormData（检查是否包含 File 对象）
    const hasFile = params && Object.values(params).some(value => value instanceof File)
    
    if (hasFile) {
      console.log('检测到文件上传，使用 FormData')
      
      // 创建 FormData 对象
      const formData = new FormData()
      
      // 遍历参数，添加到 FormData
      Object.keys(params).forEach(key => {
        const value = params[key]
        if (value !== undefined && value !== null) {
          formData.append(key, value)
        }
      })
      
      // 直接使用 axios.post，拦截器会处理 Content-Type
      axios.post(url, formData, {
        headers: {
          'token': localStorage.getItem('token') || ''
        }
      })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        console.error('文件上传失败:', err)
        reject(err.data)
      })
      
    } else {
      // 普通 JSON 请求
      axios.post(url, JSON.stringify(params), {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'token': localStorage.getItem('token') || ''
        }
      })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
    }
  })
}

// 同步post请求
export async function awaitpost (url, params) {
  let r = await axios.post(url, JSON.stringify(params))
  return r
}
